import WeakIterable from "@/prototype/utils/WeakIterable.js";

// import global from "@/prototype/global.js";

// const log = global.log.getLogger("f_mtac.storage.space.hooks");

const Hook = function(name, origin) {
    const handlers = {
        deleting: new WeakIterable(),
        updating: new WeakIterable(),
        creating: new WeakIterable()
    };
    const hook = {
        deleting: (_, data) => { // primary_key, data, transaction
            for (let handler of handlers.deleting) {
                handler(data, origin);
            }
        },
        updating: (modifications, _, data) => { // modifications, primary_key, data, transaction
            for (let handler of handlers.updating) {
                handler(data, modifications, origin);
            }
        },
        creating: (_, data) => { // primary_key, data, transaction
            for (let handler of handlers.creating) {
                handler(data, origin);
            }
        }
    };

    this.bind = (table) => {
        for (let event_name in handlers) {
            table.hook(event_name, hook[event_name]);
        }
    };

    this.unbind = (table) => {
        for (let event_name in handlers) {
            table.hook(event_name).unsubscribe(hook[event_name]);
        }
    };

    this.on = (event_name, handler) => {
        if (!(event_name in handlers)) {
            throw `unsupported ${name} subscribe event`;
        }
        handlers[event_name].add(handler);
    };

    this.off = (event_name, handler) => {
        if (!(event_name in handlers)) {
            throw `unsupported ${name} unsubscribe event`;
        }
        handlers[event_name].delete(handler);
    };
};

const HookGroup = function(group_name) {
    const handlers = {
        deleting: new WeakIterable(),
        updating: new WeakIterable(),
        creating: new WeakIterable()
    };
    const hook = {
        deleting: (data, origin) => {
            for (let handler of handlers.deleting) {
                handler(data, origin);
            }
        },
        updating: (data, modifications, origin) => {
            for (let handler of handlers.updating) {
                handler(data, modifications, origin);
            }
        },
        creating: (data, origin) => {
            for (let handler of handlers.creating) {
                handler(data, origin);
            }
        }
    };
    const group = new WeakIterable();

    this.add_subhooks = (subhooks) => {
        for(let event_name in hook) {
            subhooks.on(group_name, event_name, hook[event_name]);
        }
        group.add(subhooks);
    };

    this.delete_subhooks = (subhooks) => {
        for(let event_name in hook) {
            subhooks.off(group_name, event_name, hook[event_name]);
        }
        group.delete(subhooks);
    };

    this.bind = () => {};
    this.unbind = () => {};

    this.on = (event_name, handler) => {
        if (!(event_name in handlers)) {
            throw `unsupported ${name} subscribe event`;
        }
        handlers[event_name].add(handler);
    };

    this.off = (event_name, handler) => {
        if (!(event_name in handlers)) {
            throw `unsupported ${name} unsubscribe event`;
        }
        handlers[event_name].delete(handler);
    };
};

const Hooks = function() {
    const hooks = {};

    Object.defineProperty(this, "hook_names", {
        set: () => {},
        get: () => Object.keys(hooks)
    });

    this.add = (name, origin) => {
        hooks[name] = new Hook(name, origin);
    };

    this.add_group = (group_name) => {
        hooks[group_name] = new HookGroup(group_name);
    };

    this.add_subhooks = (subhooks) => {
        for (let group_name of subhooks.hook_names) {
            hooks[group_name].add_subhooks(subhooks);
        }
    };

    this.delete_subhooks = (subhooks) => {
        for (let group_name of subhooks.hook_names) {
            hooks[group_name].delete_subhooks(subhooks);
        }
    };

    this.bind = (database) => {
        for (let name in hooks) {
            hooks[name].bind(database[name]);
        }
    };

    this.unbind = (database) => {
        for (let name in hooks) {
            hooks[name].unbind(database[name]);
        }
    };

    this.on = (name, event_name, handler) => {
        hooks[name].on(event_name, handler);
    };

    this.off = (name, event_name, handler) => {
        hooks[name].off(event_name, handler);
    };
};


export default Hooks;
